export default {
    PENDING: 0,
    ACCEPTED: 1,
    REJECTED: 2
}